module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/collab/collab-scroll-07-2e9e6d0bf9cbfd778d14bbe258a125d5.jpg";